var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/footer/privacy-links.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/navigation-items.j2", false, "core/templates/footer/privacy-links.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderNavItem")) {
var t_4 = t_1.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_4);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")) {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")),"legal")) {
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")),"legal");
frame.set("legalSection", t_5, true);
if(frame.topLevel) {
context.setVariable("legalSection", t_5);
}
if(frame.topLevel) {
context.addExport("legalSection", t_5);
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "legalSection")),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "legalSection")),"childSlugs")) > 0) {
output += "<ul class=\"u-clearfix c-privacy-links__ul\">";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "legalSection")),"childSlugs");
if(t_8) {var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("childSlug", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
output += runtime.suppressValue((lineno = 10, colno = 65, runtime.callWrap(t_4, "renderNavItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_9),runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
["navItem", "url", "target"], 
[], 
function (l_navItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItem", l_navItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_11 = "";t_11 += "\n                            ";
var t_12;
t_12 = "noopener noreferrer";
frame.set("rel", t_12, true);
if(frame.topLevel) {
context.setVariable("rel", t_12);
}
if(frame.topLevel) {
context.addExport("rel", t_12);
}
t_11 += "\n\n                            <li class=\"u-adjacent-divider c-privacy-links__li\">";
if(runtime.memberLookup((l_navItem),"slug") == "footer-ccpa") {
if((lineno = 16, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.privacyRestriction.userIsResident",runtime.contextOrFrameLookup(context, frame, "False")]))) {
t_11 += "\n                                        ";
var t_13;
t_13 = (lineno = 17, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.ca-privacy-config.residentPrivacyLinkCopy",""]));
frame.set("displayName", t_13, true);
if(frame.topLevel) {
context.setVariable("displayName", t_13);
}
if(frame.topLevel) {
context.addExport("displayName", t_13);
}
t_11 += "\n                                    ";
;
}
else {
t_11 += "\n                                        ";
var t_14;
t_14 = runtime.memberLookup((l_navItem),"displayName");
frame.set("displayName", t_14, true);
if(frame.topLevel) {
context.setVariable("displayName", t_14);
}
if(frame.topLevel) {
context.addExport("displayName", t_14);
}
t_11 += "\n                                    ";
;
}
t_11 += "\n\n                                    <a ";
t_11 += runtime.suppressValue((lineno = 22, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["footer",runtime.memberLookup((l_navItem),"slug")])), env.opts.autoescape);
t_11 += " class=\"c-privacy-links__a c-privacy-links__a--";
t_11 += runtime.suppressValue(t_9, env.opts.autoescape);
t_11 += "\" href=\"";
t_11 += runtime.suppressValue(l_url, env.opts.autoescape);
t_11 += "\">\n                                        ";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "displayName"), env.opts.autoescape);
t_11 += "\n                                    </a>";
;
}
else {
t_11 += "<a ";
t_11 += runtime.suppressValue((lineno = 28, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["footer",runtime.memberLookup((l_navItem),"slug")])), env.opts.autoescape);
t_11 += " ";
if(l_target) {
t_11 += " target=\"";
t_11 += runtime.suppressValue(l_target, env.opts.autoescape);
t_11 += "\" ";
if(l_target == "_blank") {
t_11 += " rel=\"";
t_11 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_11 += "\" ";
;
}
t_11 += " ";
;
}
t_11 += " class=\"c-privacy-links__a\" href=\"";
t_11 += runtime.suppressValue(l_url, env.opts.autoescape);
t_11 += "\">\n                                        ";
t_11 += runtime.suppressValue(runtime.memberLookup((l_navItem),"displayName"), env.opts.autoescape);
t_11 += "\n                                    </a>";
;
}
t_11 += "</li>\n                        ";
;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
;
}
}
frame = frame.pop();
output += "</ul>";
;
}
;
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/footer/privacy-links.j2"] , dependencies)